import { CartesianGrid, Line, LineChart, XAxis, YAxis } from "recharts"

import {
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
  type ChartConfig,
} from "@/components/ui/chart.tsx"
import { numberFmt } from "@/util/numberFmt.ts"

import type { RollingChartConfig, RollingChartData } from "../types/rollingChartTypes.ts"

export default function RollingChartDisplay({
  settings,
  config,
  data,
  showSecondary,
  primaryLabel,
  secondaryLabel,
}: {
  settings: RollingChartConfig
  config: ChartConfig
  data: RollingChartData[]
  showSecondary: boolean
  primaryLabel?: string
  secondaryLabel?: string
}) {
  return (
    <ChartContainer className="w-full min-h-[200px] 2xl:max-h-[450px] flex-1" config={config}>
      <LineChart data={data} margin={{ top: 25, left: 0, right: 0, bottom: 5 }}>
        <XAxis dataKey="date" minTickGap={20} tickLine={false} />
        <YAxis
          yAxisId="primary"
          tickLine={false}
          tickFormatter={(v) => numberFmt(Number(v))}
          label={{ value: primaryLabel, angle: 270, position: "insideLeft" }}
        />
        {showSecondary && (
          <YAxis
            yAxisId="secondary"
            orientation="right"
            tickLine={false}
            tickFormatter={(v) => numberFmt(Number(v))}
            label={{
              value: secondaryLabel,
              angle: 90,
              position: "insideRight",
            }}
          />
        )}
        <ChartTooltip content={<ChartTooltipContent />} />
        <ChartLegend content={<ChartLegendContent />} />
        <CartesianGrid vertical={false} />
        <Line
          dot={false}
          type="monotone"
          dataKey="primary1"
          stroke="var(--color-primary1)"
          yAxisId="primary"
          strokeWidth={2}
        />
        {settings.primaryKPIs.length == 2 && (
          <Line
            dot={false}
            type="monotone"
            dataKey="primary2"
            stroke="var(--color-primary2)"
            yAxisId="primary"
            strokeWidth={2}
          />
        )}
        {showSecondary && (
          <Line
            dot={false}
            type="monotone"
            dataKey="secondary"
            stroke="var(--color-secondary)"
            yAxisId="secondary"
            strokeWidth={2}
          />
        )}
      </LineChart>
    </ChartContainer>
  )
}
